import { render } from "./ColumnFilterDropdown.vue?vue&type=template&id=4dfb8be0"
import script from "./ColumnFilterDropdown.vue?vue&type=script&lang=ts"
export * from "./ColumnFilterDropdown.vue?vue&type=script&lang=ts"
script.render = render

export default script